<template>

  <span class="text-nowrap">
    <span
      class="text-danger"
      v-if="value === 1">
      <i class="fas fa-thumbs-down" />
      {{ $t('Inappropriate') }}
    </span>
    <span
      class="text-warning"
      v-if="value === 2">
      <i class="fas fa-circle" />
      {{ $t('Average') }}
    </span>
    <span
      class="text-primary"
      v-if="value === 3">
      <i class="fas fa-thumbs-up" />
      {{ $t('Good') }}
    </span>
    <span
      class="text-success"
      v-if="value === 4">
      <i class="fas fa-thumbs-up" />
      <i class="fas fa-thumbs-up" />
      {{ $t('Great') }}
    </span>
  </span>

</template>

<script>
export default {
  name: 'ScoreEvaluation',
  props: [
    'value'
  ],
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Parts/ScoreEvaluation.vue